{
  "auth": {
    "agree": "Eu aceito.",
    "createAccount": "Criar conta",
    "createNewAccount": "Criar uma nova conta",
    "email": "Email",
    "login": "Entrar",
    "password": "Senha",
    "recover_password": "Recuperar senha",
    "sign_up": "Cadastrar-se",
    "keep_logged_in": "Mantenha-me conectado",
    "termsOfUse": "Termos de uso.",
    "reset_password": "Redefinir senha"
  },
  "404": {
    "title": "Esta página está pescando.",
    "text": "Se você acha que isso não está certo, envie-nos uma mensagem em ",
    "back_button": "Voltar para o painel"
  },
  "typography": {
    "primary": "Estilos de texto primários",
    "secondary": "Estilos de texto secundários"
  },
  "dashboard": {
    "user": "Usuário",
    "total_earned": "Total de Ganhos",
    "current_balance": "Saldo Disponivel",
    "affiliate_link": "Link de Afiliado",
    "share_link": "Compartilhe seu link para indicar e ganhar.",
    "copy": "Copiar",
    "total_commissions": "Total de Comissões",
    "career_plan": "Plano de Carreira",
    "current_level": "Você está atualmente no nível",
    "next_level": "Progrida até o nível",
    "next_level_short": "Próximo nível",
    "current_bonus": "Bônus atual",
    "next_bonus": "Próximo bônus",
    "residual_note": "Você recebe 1% recorrente sobre o PLR dos seus indicados diretos até a 5ª geração.",
    "my_quotas": "Minhas Cotas",
    "view_all": "Ver todas",
    "value": "Valor",
    "created_at": "Criada em",
    "finished_at": "Finaliza em",
    "status": "Status",
    "status_finished": "Finalizada",
    "status_in_progress": "Em andamento",
    "copied_success": "Link copiado com sucesso",
    "load_error": "Erro ao carregar o dashboard",
    "charts": {
      "trendyTrends": "Tendências na moda",
      "showInMoreDetail": "Mostrar em mais detalhes",
      "showInLessDetail": "Mostrar em menos detalhes",
      "loadingSpeed": "Velocidade de carregamento",
      "topContributors": "Principais colaboradores",
      "showNextFive": "Mostrar próximos cinco",
      "commits": "Commits"
    },
    "info": {
      "componentRichTheme": "tema rico em componentes",
      "completedPullRequests": "solicitações de pull concluídas",
      "users": "usuários",
      "points": "pontos",
      "units": "unidades",
      "exploreGallery": "Explorar galeria",
      "viewLibrary": "Ver Biblioteca",
      "commits": "commits",
      "components": "componentes",
      "teamMembers": "membros da equipe"
    },
    "tabs": {
      "overview": {
        "title": "Visão Geral",
        "built": "Construído com o framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Design fresco e nítido",
        "mobile": "Responsivo e otimizado para dispositivos móveis",
        "components": "Toneladas de componentes úteis",
        "nojQuery": "Completamente livre de jQuery"
      },
      "billingAddress": {
        "title": "Endereço de Cobrança",
        "personalInfo": "Informação Pessoal",
        "firstName": "Nome e Sobrenome",
        "email": "Email",
        "address": "Endereço",
        "companyInfo": "Informação da Empresa",
        "city": "Cidade",
        "country": "País",
        "infiniteConnections": "Conexões infinitas",
        "addConnection": "Adicionar Conexão"
      },
      "bankDetails": {
        "title": "Detalhes Bancários",
        "detailsFields": "Campos de Detalhes",
        "bankName": "Nome do Banco",
        "accountName": "Nome da Conta",
        "sortCode": "Código de Ordenação",
        "accountNumber": "Número da Conta",
        "notes": "Notas",
        "sendDetails": "Enviar Detalhes"
      }
    },
    "navigationLayout": "layout de navegação",
    "topBarButton": "Barra Superior",
    "sideBarButton": "Barra Lateral"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "Inglês",
    "spanish": "Espanhol",
    "simplified_chinese": "Chinês Simplificado",
    "persian": "Persa"
  },
  "sidebar": {
    "dashboard": "Início",
    "content_education": "Conteúdo educativo",
    "stake": "Stake",
    "cotas": "Ações",
    "history": "Histórico",
    "network": "Network",
    "support": "Suporte",
    "copytrade": "Copytrade",
    "operations": "Ganhos Detalhados",
    "primezord": "Primezord",
    "earnings": "Rendimentos",
    "saldo_disponivel": "Saldo disponível",
    "voltar_corretora": "Voltar para Corretora",
    "tempo_sessao": "Tempo de Sessão Restante"
  },
  "menu": {
    "auth": "Autenticação",
    "buttons": "Botões",
    "timelines": "Linhas do Tempo",
    "dashboard": "Painel de Controle",
    "billing": "Cobrança",
    "login": "Entrar",
    "signUp": "Cadastrar-se",
    "preferences": "Preferências",
    "payments": "Pagamentos",
    "pricing-plans": "Planos de Preços",
    "login-singup": "Entrar/Cadastrar",
    "404": "Páginas 404",
    "faq": "FAQ"
  },
  "messages": {
    "all": "Ver todas as mensagens",
    "new": "Novas mensagens de {name}",
    "mark_as_read": "Marcar como Lido"
  },
  "navbar": {
    "messageUs": "Perguntas de desenvolvimento web:",
    "repository": "Repositório GitHub",
    "nova_stake": "Nova Cota",
    "sacar": "Sacar",
    "trazer_corretora": "Trazer da Corretora",
    "saldo": "Disponivel para Saque",
    "sair": "Sair",
    "historico": "Histórico",
    "deposit": "Depósito",
    "home": "Inicio"
  },
  "notifications": {
    "all": "Ver todas as notificações",
    "mark_as_read": "Marcar como lida",
    "sentMessage": "enviou uma mensagem",
    "uploadedZip": "fez upload de um novo arquivo Zip com {type}",
    "startedTopic": "iniciou um novo tópico"
  },
  "user": {
    "language": "Mudar Idioma",
    "logout": "Sair",
    "profile": "Meu Perfil",
    "settings": "Configurações",
    "billing": "Faturamento",
    "faq": "FAQ",
    "helpAndSupport": "Ajuda & Suporte",
    "projects": "Projetos",
    "account": "Conta",
    "explore": "Explorar",
    "title": "Atualizar Perfil",
    "avatar_title": "Foto de Perfil",
    "account_data": "Dados da Conta",
    "phone": "Telefone",
    "birthday": "Data de nascimento",
    "new_password": "Nova Senha",
    "confirm_password": "Confirmação de senha",
    "save": "Salvar Tudo"
  },
  "profile": {
    "avatarTitle": "Foto de Perfil",
    "selectImage": "Selecione uma imagem.",
    "saveAvatar": "Salvar Avatar",
    "personalInfo": "Informações Pessoais",
    "birth": "Data de nascimento",
    "saveData": "Salvar Dados",
    "changePassword": "Alterar Senha",
    "newPassword": "Nova Senha",
    "confirmPassword": "Confirmação de senha",
    "savePassword": "Salvar Senha",
    "updatedSuccess": "Atualizado com sucesso.",
    "updatedError": "Erro ao atualizar.",
    "passwordMismatch": "As senhas não coincidem.",
    "title": "Atualizar Perfil",
    "avatar_title": "Foto de Perfil",
    "account_data": "Dados da Conta",
    "phone": "Telefone",
    "birthday": "Data de nascimento",
    "new_password": "Nova Senha",
    "confirm_password": "Confirmação de senha",
    "save": "Salvar Tudo"
  },
  "treeView": {
    "basic": "Básico",
    "icons": "Icones",
    "selectable": "Selecionável",
    "editable": "Editável",
    "advanced": "Advançado"
  },
  "chat": {
    "title": "Gráficos"
  },
  "helpAndSupport": "Ajuda & Suporte",
  "aboutVuesticAdmin": "Sobre Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Pesquisar",
    "noOptions": "Itens não encontrados",
    "ok": "OK",
    "cancel": "Cancelar",
    "uploadFile": "Carregar arquivo",
    "undo": "Desfazer",
    "dropzone": "Solte os arquivos aqui para carregar",
    "fileDeleted": "Arquivo excluído",
    "closeAlert": "fechar alerta",
    "backToTop": "voltar ao topo",
    "toggleDropdown": "alternar dropdown",
    "carousel": "carrossel",
    "goPreviousSlide": "ir para o slide anterior",
    "goNextSlide": "ir para o próximo slide",
    "goSlide": "ir para o slide {index}",
    "slideOf": "slide {index} de {length}",
    "close": "fechar",
    "openColorPicker": "abrir seletor de cores",
    "colorSelection": "seleção de cores",
    "colorName": "cor {color}",
    "decreaseCounter": "diminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "selecionar todas as linhas",
    "sortColumnBy": "ordenar coluna por {name}",
    "selectRowByIndex": "selecionar linha {index}",
    "resetDate": "redefinir data",
    "nextPeriod": "próximo período",
    "switchView": "alternar visualização",
    "previousPeriod": "período anterior",
    "removeFile": "remover arquivo",
    "reset": "redefinir",
    "pagination": "paginação",
    "goToTheFirstPage": "ir para a primeira página",
    "goToPreviousPage": "ir para a página anterior",
    "goToSpecificPage": "ir para a página {page}",
    "goToSpecificPageInput": "insira o número da página",
    "goNextPage": "ir para a próxima página",
    "goLastPage": "ir para a última página",
    "currentRating": "classificação atual {value} de {max}",
    "voteRating": "votar classificação {value} de {max}",
    "optionsFilter": "filtro de opções",
    "splitPanels": "dividir painéis",
    "movePaginationLeft": "mover paginação para a esquerda",
    "movePaginationRight": "mover paginação para a direita",
    "resetTime": "redefinir horário",
    "closeToast": "fechar notificação",
    "selectedOption": "Opção selecionada",
    "noSelectedOption": "Nenhuma opção selecionada",
    "breadcrumbs": "caminho",
    "counterValue": "valor do contador",
    "selectedDate": "data selecionada",
    "selectedTime": "horário selecionado",
    "progressState": "estado de progresso",
    "color": "cor",
    "next": "Próximo",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "etapa",
    "progress": "progresso",
    "loading": "Carregando",
    "sliderValue": "O valor atual do controle deslizante é {value}",
    "switch": "Alternar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "Tipo de arquivo incorreto",
    "select": "Selecione uma opção"
  },
  "stakes": {
    "start_date": "Data da Contratação",
    "create_in": "Data da Contratação",
    "duration": "Prazo",
    "status": "Status",
    "status_active": "Em andamento",
    "status_Finalizada": "Finalizada",
    "amount": "Valor da Ação",
    "profit": "Lucro Gerado",
    "my_quotas": "Minhas Ações",
    "create_new": "Contratar Ação",
    "empty_title": "Você ainda não possui ações",
    "empty_subtitle": "Contrate sua primeira ação",
    "create_first": "Contratar Ação",
    "progress": "Progresso",
    "cancel_button": "Cancelar Ação",
    "modal_title": "Cancelar Ação",
    "modal_description": "Tem certeza que deseja cancelar a Ação no valor de",
    "created_in": "Criada Em",
    "modal_close": "Fechar",
    "modal_confirm": "Confirmar Cancelamento"
  },
  "history": {
    "copytrade": "CopyTrade",
    "cotas": "Cotas",
    "depositos": "Depósitos",
    "stakes": "Stakes",
    "operacoes": "Operações",
    "saques": "Saques",
    "bonus": "Bônus",
    "residual": "Residual",
    "primezord": "Primezord",
    "start_date": "Data Início",
    "end_date": "Data Fim",
    "status": {
      "canceled": "Cancelado",
      "complete": "Completo",
      "in_progress": "Em andamento",
      "finished": "Finalizada"
    },
    "columns": {
      "date": "Data",
      "value": "Valor",
      "status": "Status",
      "invested": "Valor Investido",
      "profit": "Lucro Gerado",
      "pair": "Par",
      "payout": "Payout",
      "description": "Descrição",
      "source": "Origem",
      "reference": "Referência",
      "total": "Total",
      "percentage": "Porcentagem",
      "notes": "Notas"
    }
  },
  "network": {
    "email": "Email",
    "phone": "Telefone",
    "balance": "Saldo",
    "loading": "Carregando rede..."
  },
  "copytrade": {
    "title": "CopyTrades Contratados",
    "create": "Criar Novo CopyTrade",
    "empty": "Nenhum CopyTrade contratado no momento.",
    "start_date": "Data de Início",
    "status": "Status",
    "status_active": "Em andamento",
    "status_expired": "Expirado",
    "invested": "Capital Investido",
    "profit": "Lucro Gerado",
    "modal_title": "Criar novo CopyTrade",
    "modal_description": "Selecione o valor que deseja investir.",
    "investment_amount": "Valor do Investimento",
    "select": "Selecione...",
    "start_copy": "Iniciar CopyTrade",
    "cancel": "Cancelar",
    "alert_select_amount": "Selecione um valor"
  },
  "operations": {
    "start_date": "Data Início",
    "end_date": "Data Fim",
    "asset": "Ativo",
    "all": "Todos",
    "loading": "Carregando operações...",
    "columns": {
      "date": "Data",
      "asset": "Ativo",
      "payout": "Payout"
    }
  },
  "primezord": {
    "title": "Primezord",
    "deposit": "Depósito",
    "withdraw": "Saque",
    "invest": "Investimento",
    "modal_deposit": "Realizar Depósito",
    "modal_withdraw": "Solicitar Saque",
    "modal_invest": "Novo Investimento",
    "modal_subtitle": "Selecione o valor desejado.",
    "modal_value": "Valor",
    "modal_confirm": "Confirmar",
    "modal_cancel": "Cancelar",
    "balance_label": "Saldo Zord",
    "withdraw_balance_label": "Disponivel pra saque",
    "taxa": "Taxa do dolar",
    "table_date": "Data",
    "table_value": "Valor",
    "table_status": "Status",
    "loading": "Carregando investimentos...",
    "blocked_balance_label": "Bloqueado",
    "alert_value": "Selecione um valor"
  },
  "support": {
    "title": "Fale com o Suporte",
    "description": "Seja para tirar dúvidas, resolver um problema ou só conversar com nossa equipe, estamos prontos para te atender. Escolha abaixo seu canal preferido e fale com a gente! Nosso suporte é feito por pessoas reais, com atendimento rápido e humanizado. 😉"
  },
  "earnings": {
    "title": "Rendimentos",
    "start_date": "Data Início",
    "end_date": "Data Fim",
    "date": "Data",
    "amount": "Valor",
    "action": "Ação",
    "download": "Baixar PDF",
    "loading": "Carregando rendimentos..."
  },
  "modal": {
    "newQuota": "Nova Cota",
    "confirmation": "Confirmação",
    "payment": "Pagamento",
    "choosePlan": "Escolha o plano",
    "quotaValue": "Valor da Cota:",
    "continue": "Continuar",
    "confirmPurchase": "Tem certeza que deseja adquirir a cota do plano {plan} no valor de R$ {amount}?",
    "acceptTerms": "Eu li e aceito os",
    "termsOfUse": "termos de uso",
    "confirm": "Confirmar",
    "paymentValue": "Pagamento R$ {amount}.",
    "paymentInstruction": "Finalize o pagamento utilizando o QR Code ou copie a linha PIX abaixo.",
    "pixLine": "Linha digitável",
    "copy": "Copiar",
    "loadingPayment": "Carregando",
    "back": "Voltar",
    "alert_message": "⚠\uFE0F Pode levar até 1 hora para confirmarmos seu pagamento. Fique tranquilo, avisaremos assim que estiver tudo certo!",
    "finish": "Concluir"
  }
}
